$(document).on('turbolinks:load', () => {
  const player = $('.main-video > #player');

  player.attr('src', player.data('src'));
});
